var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_4041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3332C11.0944 18.3346 12.1784 18.1197 13.1897 17.7008C14.2009 17.2819 15.1194 16.6673 15.8923 15.8923C16.6673 15.1194 17.2819 14.2009 17.7008 13.1897C18.1197 12.1784 18.3346 11.0944 18.3332 9.99984C18.3346 8.90529 18.1197 7.82125 17.7008 6.81002C17.2819 5.79879 16.6673 4.88031 15.8923 4.10734C15.1194 3.33236 14.2009 2.71776 13.1897 2.29888C12.1784 1.88 11.0944 1.66509 9.99984 1.66651C8.90529 1.66512 7.82125 1.88003 6.81002 2.29891C5.79879 2.71779 4.88031 3.33237 4.10734 4.10734C3.33237 4.88031 2.71779 5.79879 2.29891 6.81002C1.88003 7.82125 1.66512 8.90529 1.66651 9.99984C1.66509 11.0944 1.88 12.1784 2.29888 13.1897C2.71776 14.2009 3.33236 15.1194 4.10734 15.8923C4.88031 16.6673 5.79879 17.2819 6.81002 17.7008C7.82125 18.1197 8.90529 18.3346 9.99984 18.3332Z",
    stroke: "#FE4A49",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10L9.1665 12.5L14.1665 7.5",
    stroke: "#FE4A49",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_4041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTicket);
export default __webpack_public_path__ + "static/media/close-ticket.804c312b80eb6d1b6339dc794a68f537.svg";
export { ForwardRef as ReactComponent };